import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
export const Banner = (props) => {
    const { enabled, transitionDurationMs = 1000, children, vertical } = props;
    const [outOfScreen, setOutOfScreen] = React.useState(!enabled);
    React.useEffect(() => {
        if (enabled) {
            setOutOfScreen(false);
        }
        else {
            const timeout = setTimeout(() => {
                setOutOfScreen(true);
            }, transitionDurationMs);
            return () => {
                clearTimeout(timeout);
            };
        }
    }, [enabled, transitionDurationMs]);
    const changedPos = outOfScreen ? '-100%' : enabled ? '0%' : '100%';
    const xPos = vertical ? '0%' : changedPos;
    const yPos = vertical ? changedPos : '0%';
    const transition = outOfScreen ? undefined : `transform ${transitionDurationMs / 1000}s ease-in-out`;
    return _jsx("div", { style: { height: '100%', width: '100%', transform: `translate(${xPos}, ${yPos})`, transition }, children: children });
};
//# sourceMappingURL=Banner.js.map